import React from 'react';
import { Typography } from '@material-ui/core';
import { useStyles } from './styles';

interface EventDescriptionProps {
  key: string;
  title: string;
  bullets: string[];
}

const EventDescription = ({ key, title, bullets }: EventDescriptionProps) => {
  const classes = useStyles();

  return (
    <React.Fragment key={key}>
      <Typography variant="h4" className={classes.callsTitle}>
        {title}
      </Typography>
      <ul>
        {bullets?.map((bullet: string) => (
          <li key={bullet}>{bullet}</li>
        ))}
      </ul>
    </React.Fragment>
  );
};

export default EventDescription;
